"use strict";
// tslint:disable:deprecation
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ReactDOM = require("react-dom");
var SharedWidgets_1 = require("../SharedWidgets");
var TabStyles_1 = require("../styles/TabStyles");
var DomUtil_1 = require("../utils/DomUtil");
var GlobalPointerDownOutsideListener_1 = require("../utils/GlobalPointerDownOutsideListener");
var Overlay_1 = require("../utils/Overlay");
var DomWidgets_1 = require("./DomWidgets");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var ListMenuWidget_1 = require("./ListMenuWidget");
var DefaultAnchorOrigin = {
    vertical: Overlay_1.VerticalOriginOption.bottom,
    horizontal: Overlay_1.HorizontalOriginOption.left
};
var Spacing = TabStyles_1.TabStyles.Spacing, Sizing = TabStyles_1.TabStyles.Sizing, Colors = TabStyles_1.TabStyles.Colors, Shadow = TabStyles_1.TabStyles.Shadow;
exports.FlyoutListMenuStyles = {
    backgroundColor: 'white',
    borderColor: Colors.L6,
    borderRadius: Sizing.BorderRadius,
    borderStyle: 'solid',
    borderWidth: Sizing.BorderWidth,
    boxShadow: Shadow.Standard
};
var GenericFlyoutListMenuWidget = /** @class */ (function (_super) {
    tslib_1.__extends(GenericFlyoutListMenuWidget, _super);
    function GenericFlyoutListMenuWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSearchEscape = function () {
            if (!!_this.state.searchString) {
                _this.setState({ searchString: '' });
            }
            else {
                _this.onRequestClose();
            }
        };
        _this.handleCancelSearch = function () {
            _this.setState({ searchString: undefined });
        };
        _this.handleSearchChanged = function (searchString) {
            _this.setState({ searchString: searchString });
        };
        _this.handleSearchEnter = function () {
            if (_this.listWidgetInstance) {
                _this.listWidgetInstance.selectActive();
            }
        };
        _this.getFilteredMenuItems = function () {
            if (!_this.state.searchString) {
                return _this.props.menuItemInfos;
            }
            // filter to items which case-insensitively contain searchString
            return _this.props.menuItemInfos.filter(function (item) {
                return item.isDivider || (item.keyboardAccessibleValue &&
                    item.keyboardAccessibleValue.toUpperCase().indexOf(_this.state.searchString.toUpperCase()) >= 0);
            }).filter(function (item, index, items) {
                return !(item.isDivider && index > 0 && items[index - 1].isDivider);
            }).filter(function (item, index, items) {
                return !(item.isDivider && (index === 0 || index === items.length - 1));
            });
        };
        _this.onRequestClose = function () {
            _this.props.requestCloseAll();
        };
        _this.handleKeyDown = function (e) {
            switch (e.key) {
                case 'ArrowUp':
                case 'ArrowDown':
                    if (_this.state.focusLocation === 'search' && _this.getFilteredMenuItems().length > 0) {
                        _this.setState({ focusLocation: 'list' });
                    }
                    else {
                        return;
                    }
                    break;
                case 'Tab':
                    // this case may need to change if we move toward combobox behavior
                    if (_this.state.focusLocation === 'search') {
                        if (_this.getFilteredMenuItems().length > 0) {
                            _this.setState({ focusLocation: 'list' });
                        }
                    }
                    else if (_this.props.__UNSUPPORTED__showSearchField) {
                        _this.setState({ focusLocation: 'search' });
                    }
                    break; // regardless, trap focus
                default:
                    return; // don't prevent default / stop propagation for unhandled keys
            }
            e.preventDefault();
            e.stopPropagation();
        };
        _this.setSearchDomNode = function (ref) {
            _this.searchDomNode = ref;
        };
        _this.handleListRef = function (ref) {
            _this.listWidgetInstance = ref;
        };
        _this.setFlyoutDomNode = function (ref) {
            _this.flyoutDomNode = ReactDOM.findDOMNode(ref);
        };
        _this.handleFocus = function (event) {
            var target = event.target;
            var listDomNode = _this.getListDomNode();
            var focusLocation = _this.state.focusLocation;
            if (_this.searchDomNode && _this.searchDomNode.contains(target)) {
                focusLocation = 'search';
            }
            else if (listDomNode && listDomNode.contains(target)) {
                focusLocation = 'list';
            }
            if (_this.state.focusLocation !== focusLocation) {
                _this.setState({ focusLocation: focusLocation });
            }
        };
        _this.getAnchorClientRect = function () {
            if (_this.props.getAnchorClientRect) {
                return _this.props.getAnchorClientRect();
            }
            return _this.props.anchorEl ? _this.props.anchorEl.getBoundingClientRect() : undefined;
        };
        _this.state = {
            searchString: '',
            focusLocation: _this.props.__UNSUPPORTED__showSearchField ? 'search' : 'list',
        };
        return _this;
    }
    GenericFlyoutListMenuWidget.prototype.componentDidMount = function () {
        // Everything outside the toggling element/button or the flyout should trigger a close on mousedown
        if (this.flyoutDomNode) {
            this.pointerDownOutsideFlyoutListenerUnsubscribe = GlobalPointerDownOutsideListener_1.GlobalPointerDownOutsideListener.subscribe(this.flyoutDomNode, this.onRequestClose);
        }
        if (this.props.toggleEl) {
            this.pointerDownOutsideToggleElListenerUnsubscribe = GlobalPointerDownOutsideListener_1.GlobalPointerDownOutsideListener.subscribe(this.props.toggleEl, this.onRequestClose);
        }
        this.syncFocus();
    };
    GenericFlyoutListMenuWidget.prototype.componentDidUpdate = function () {
        this.syncFocus();
    };
    GenericFlyoutListMenuWidget.prototype.componentWillUnmount = function () {
        if (this.pointerDownOutsideFlyoutListenerUnsubscribe) {
            this.pointerDownOutsideFlyoutListenerUnsubscribe();
        }
        if (this.pointerDownOutsideToggleElListenerUnsubscribe) {
            this.pointerDownOutsideToggleElListenerUnsubscribe();
        }
        // Return focus to the toggle element
        if (this.props.toggleEl && this.props.shouldReturnFocusToToggleEl) {
            /**
             * We must use setTimeout here because it is likely a focus event is causing the flyoutlistmenu to unmount.
             * We need to queue this event so that it is called after that focus event.
             */
            DomUtil_1.timeoutFocus(this.props.toggleEl);
        }
    };
    GenericFlyoutListMenuWidget.prototype.syncFocus = function () {
        if (this.state.focusLocation === 'list') {
            var listDomNode = this.getListDomNode();
            if (listDomNode) {
                listDomNode.focus();
            }
        }
        else if (this.state.focusLocation === 'search') {
            if (this.searchDomNode) {
                this.searchDomNode.focus();
            }
        }
    };
    GenericFlyoutListMenuWidget.prototype.getListDomNode = function () {
        return ReactDOM.findDOMNode(this.listWidgetInstance);
    };
    GenericFlyoutListMenuWidget.prototype.renderSearchField = function () {
        if (!this.props.__UNSUPPORTED__showSearchField) {
            return undefined;
        }
        return (React.createElement(SharedWidgets_1.SearchFieldWidget, { containerStyle: {
                margin: Spacing.SmallSpace,
                marginBottom: Spacing.DefaultSpace,
            }, handleCancelSearch: this.handleCancelSearch, handleChange: this.handleSearchChanged, handleEnter: this.handleSearchEnter, handleEscape: this.handleSearchEscape, inputRef: this.setSearchDomNode, placeholder: this.props.__UNSUPPORTED__searchDefaultText, shouldSelectTextOnFocus: false, testId: 'flyout-search', text: this.state.searchString }));
    };
    GenericFlyoutListMenuWidget.prototype.render = function () {
        if (!!this.props.__UNSUPPORTED__searchDefaultText) {
            console.warn('__UNSUPPORTED__searchDefaultText is an unsupported/deprecated prop and should not be used');
        }
        if (!!this.props.__UNSUPPORTED__showSearchField) {
            console.warn('__UNSUPPORTED__showSearchField is an unsupported/deprecated prop and should not be used');
        }
        var overlayProps = {
            allowAutoPosition: this.props.allowAutoPosition,
            anchorOrigin: this.props.anchorOrigin || DefaultAnchorOrigin,
            getAnchorClientRect: this.getAnchorClientRect,
            handleScrollOnScrollingRoot: this.props.handleScrollOnScrollingRoot,
            leftFromOverlaidPosition: this.props.leftFromOverlaidPosition,
            scrollingRootId: this.props.scrollingRootId,
            shouldAutoPositionOnScrollingRootScroll: this.props.shouldAutoPositionOnScrollingRootScroll,
            stackedOrigin: this.props.stackedOrigin,
            stackingRootId: this.props.stackingRootId,
            topFromOverlaidPosition: this.props.topFromOverlaidPosition,
            zIndex: this.props.zIndex,
        };
        var blockProps = {
            onFocus: this.handleFocus,
            onKeyDown: this.handleKeyDown,
            ref: this.setFlyoutDomNode,
            style: tslib_1.__assign({}, exports.FlyoutListMenuStyles, this.props.menuStyle),
        };
        var listMenuProps = {
            __INTERNAL__focusIndex: this.props.__INTERNAL__focusIndex,
            focusDisabled: this.state.focusLocation === 'search',
            id: this.props.id,
            letterSearchDisabled: this.props.__UNSUPPORTED__showSearchField,
            maxHeight: this.props.maxHeight,
            menuItemInfos: this.getFilteredMenuItems(),
            onEscapeKeyUp: this.props.onEscapeKeyUp,
            onLeftArrowKeyDown: this.props.onLeftArrowKeyDown,
            onMouseEnter: this.props.onMouseEnter,
            onSelect: this.props.onSelect,
            requestCloseAll: this.onRequestClose,
            role: this.props.role,
            scrollingRootId: this.props.scrollingRootId,
            stackingRootId: this.props.stackingRootId,
            subMenuAllowAutoPosition: this.props.allowAutoPosition,
            subMenuShouldAutoPositionOnScrollingRootScroll: this.props.shouldAutoPositionOnScrollingRootScroll,
            testId: this.props.testId,
            zIndex: this.props.zIndex,
        };
        return (React.createElement(Overlay_1.Overlay, tslib_1.__assign({}, overlayProps),
            React.createElement(DomWidgets_1.Block, tslib_1.__assign({}, blockProps),
                this.renderSearchField(),
                React.createElement(ListMenuWidget_1.ListMenuWidget, tslib_1.__assign({}, listMenuProps, { ref: this.handleListRef })))));
    };
    GenericFlyoutListMenuWidget.defaultProps = {
        role: 'menu',
        shouldReturnFocusToToggleEl: true
    };
    return GenericFlyoutListMenuWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.GenericFlyoutListMenuWidget = GenericFlyoutListMenuWidget;
//# sourceMappingURL=FlyoutListMenuWidget.js.map